import React from "react";
import { motion } from "framer-motion";
import {
    FaWrench,
    FaTools,
    FaRegHandshake,
    FaPhoneAlt,
    FaEnvelope,
    FaArrowRight,
} from "react-icons/fa";
import "./App.css";

function App() {
    return (
        <div className="App">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-image"></div>
                <div className="hero-overlay"></div>
                <div className="container">
                    <motion.div
                        className="hero-content"
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <div className="logo-header">
                            <h1 className="logo-main">Seymentech</h1>
                            <p className="logo-sub">CV & Loodgieters</p>
                        </div>

                        <motion.h2
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.3, duration: 0.8 }}
                            className="hero-title"
                        >
                            Betrouwbare CV- en loodgietersspecialisten in Den Haag
                        </motion.h2>

                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.6, duration: 0.8 }}
                            className="hero-description"
                        >
                            Altijd klaar om te helpen! Professioneel vakmanschap met persoonlijke aandacht.
                        </motion.p>

                        <motion.div
                            className="contact-buttons"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.9, duration: 0.8 }}
                        >
                            <a href="tel:+31641680710" className="contact-button phone">
                                <FaPhoneAlt />
                                <span>06 4168 0710</span>
                                <FaArrowRight className="arrow" />
                            </a>

                            <a href="mailto:nureddinakbaba@live.nl" className="contact-button email">
                                <FaEnvelope />
                                <span>Stuur een email</span>
                                <FaArrowRight className="arrow" />
                            </a>
                        </motion.div>
                    </motion.div>
                </div>
            </section>

            {/* Over ons */}
            <section className="over-ons">
                <div className="container">
                    <motion.div
                        className="section-content"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="section-title">Over Seymentech</h2>
                        <p className="section-text">
                            Wij zijn een lokaal bedrijf in Den Haag dat gespecialiseerd is in
                            CV-installaties en loodgieterswerk. Met jarenlange ervaring en
                            vakmanschap bieden wij betrouwbare oplossingen voor zowel
                            particulieren als bedrijven.
                        </p>
                        <div className="highlight-box">
                            <p>Klanttevredenheid en vakmanschap staan bij ons centraal.</p>
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* Diensten */}
            <section className="diensten">
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="section-title">Onze Diensten</h2>
                        <p className="section-subtitle">Professionele oplossingen voor al uw sanitair en verwarming</p>
                    </motion.div>

                    <div className="services-grid">
                        {[
                            {
                                icon: <FaWrench />,
                                title: "Loodgieterswerk",
                                description: "Reparaties, leidingwerk en complete installaties met professioneel vakmanschap.",
                                delay: 0.1
                            },
                            {
                                icon: <FaTools />,
                                title: "CV-installaties",
                                description: "Installatie, onderhoud en reparatie van moderne verwarmingssystemen.",
                                delay: 0.2
                            },
                            {
                                icon: <FaRegHandshake />,
                                title: "Zakelijk & Particulier",
                                description: "Oplossingen op maat voor woningen, bedrijven en grote projecten.",
                                delay: 0.3
                            },
                        ].map((service, index) => (
                            <motion.div
                                key={service.title}
                                className="service-card"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: service.delay, duration: 0.6 }}
                                viewport={{ once: true }}
                                whileHover={{ y: -10 }}
                            >
                                <div className="service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Direct Contact */}
            <section className="direct-contact">
                <div className="container">
                    <motion.div
                        className="contact-cards"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <div className="contact-header">
                            <h2>Direct contact</h2>
                            <p>Wij staan voor u klaar</p>
                        </div>

                        <div className="contact-options">
                            <motion.a
                                href="tel:+31641680710"
                                className="contact-option"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <div className="contact-icon">
                                    <FaPhoneAlt />
                                </div>
                                <div className="contact-info">
                                    <h3>Bel ons direct</h3>
                                    <p>06 4168 0710</p>
                                    <span className="contact-note">24/7 bereikbaar voor spoed</span>
                                </div>
                            </motion.a>

                            <motion.a
                                href="mailto:nureddinakbaba@live.nl"
                                className="contact-option"
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <div className="contact-icon">
                                    <FaEnvelope />
                                </div>
                                <div className="contact-info">
                                    <h3>Stuur een email</h3>
                                    <p>nureddinakbaba@live.nl</p>
                                    <span className="contact-note">Reactie binnen 2 uur</span>
                                </div>
                            </motion.a>
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* Footer */}
            <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-logo">
                            <h3>Seymentech</h3>
                            <p>CV & Loodgieters</p>
                        </div>
                        <div className="footer-info">
                            <p>Betrouwbare CV- en loodgietersspecialisten in Den Haag</p>
                            <p className="copyright">© {new Date().getFullYear()} Seymentech. Alle rechten voorbehouden.</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default App;